import React, { useState, useEffect } from "react";
import UserIcon from '../assets/images/login-flow/user.svg';
import PasswordIcon from '../assets/images/login-flow/password.svg';
import { Link } from 'react-router-dom';
import { Form, Button, Col, Row } from "react-bootstrap";
import '../scss/login.scss';


import { useDispatch, useSelector } from "react-redux";
import { login } from "../features/auth/authActions";
import { getPageContent } from "../features/visitor/visitorActions";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify"; // Import toast
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

function Login() {
  
  const [headerData, setHeaderData] = useState(null);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, successMessage, errorMessage } = useSelector((state) => state.auth);
  const { pageResponse } = useSelector((state) => state.visitor);

  const validate = () => {
    const errors = {};

    // Check for empty fields
    if (!username) errors.username = "Username is required.";
    if (!password) errors.password = "Password is required.";
    
    // Check password length
    if (password && password.length < 8)
      errors.password = "Password must be at least 8 characters long.";

    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Initial blank errors
    setErrors({});

    // Validate form inputs
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // Dismiss any currently visible toasts
    toast.dismiss();

    // Dispatch registration action
    let data = {
      username: username,
      password: password
    };
  
    dispatch(login(data));
  };


  // Show success and error toasts
  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage, { autoClose: 3000, hideProgressBar: true });
  
      const orderData = localStorage.getItem("orderData");
  
      setTimeout(() => {
        if (orderData) {
          window.location.href = "/signup-step?step=5";
        } else {
          window.location.href = "/profile";
        }
      }, 1500); // Navigate after 3 seconds
    }
  
    if (errorMessage) {
      toast.error(errorMessage, { autoClose: 3000, hideProgressBar: true });
    }
  }, [successMessage, errorMessage, navigate]);

  
  useEffect(() => {
    dispatch(getPageContent());
  }, [dispatch]);
  
  useEffect(() => {
    if(pageResponse){
      let footer = pageResponse.find(r => r.code === 'footer');
      setHeaderData(footer.footer_section);
    }
  }, [pageResponse]);

 
  useEffect(() => {
    localStorage.removeItem("token");
  }, []);

  return (
    <>

      <Helmet>
        <title>Log In | Helpotani</title>
        <meta name="description" content="Access your Helpotani account. Sign in to view your orders, manage your account, and more." />
        <meta name="keywords" content="Sign In, Login, Helpotani, Account, Healthcare" />
      </Helmet>
      

      <section className='login'>
        <div className="login-box">
          <Link to="/" className="logo-img">
            <img src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${headerData?.main_logo}`} alt="" />            
          </Link>
            <h1>Login</h1>
            <p>Please enter your details to access<br/>your account.</p>
            <Form onSubmit={handleSubmit}>
                <Form.Group controlId="formUsername" className="form-group"> 
                  <Form.Label>Username</Form.Label>
                  <div className="input-group">
                    <Form.Control
                      type="text"
                      placeholder="Username"
                      value={username}
                      onChange={(e) => {
                        let value = e.target.value.toLowerCase(); // Convert to lowercase
                        // Allow only letters, numbers, underscores (_), and at (@)
                        if (/^[a-z0-9_@]*$/.test(value)) {
                          setUsername(value);
                        }
                      }}
                      isInvalid={!!errors.username}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.username}
                    </Form.Control.Feedback>
                    <img src={UserIcon} alt="Username" />  
                  </div>
                </Form.Group>
                <Form.Group controlId="formPassword" className="form-group">
                  <Form.Label>Password</Form.Label>
                  <div className="input-group">
                  <Form.Control
                      type="password"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      isInvalid={!!errors.password}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.password}
                    </Form.Control.Feedback>
                     <img src={PasswordIcon} alt="Username" />  
                  </div>
                </Form.Group>
                <Form.Group className="form-group">
                  <Link to="/forgot-password" className="forgot-password">Forgot Password?</Link>
                </Form.Group>

                <Button
                    className="custom-bttn"
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? (
                      <FontAwesomeIcon
                        icon={faSpinner}
                        spin
                        size="lg"
                        className="spinner-icon"
                      />
                    ) : (
                      "Log In"
                    )}
                  </Button>

              <Row>
                <Col className="text-center">
                  <p className="login-footer-text">Haven't created an account yet? <Link to="/register">&nbsp;Register</Link> </p>
                </Col>
              </Row>
            </Form>
        </div>

      </section> 
    </>
  )
}
export default Login 


